import { render, staticRenderFns } from "./section.vue?vue&type=template&id=5de0a072&scoped=true&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"
import style0 from "./section.vue?vue&type=style&index=0&id=5de0a072&prod&lang=stylus&scoped=true&"
import style1 from "./section.vue?vue&type=style&index=1&id=5de0a072&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de0a072",
  null
  
)

export default component.exports